<template>
    <div mt-1>
        <v-layout row wrap fluid>
            <v-flex xs12 sm6 pa-2 
                v-for="item in settingItems" :key="item.pathName">
                <v-card style="min-height:250px;cursor: pointer;" 
                    @click.native="onMenuClick(item.pathName)">
                    <v-card-text class="text-xs-center">
                        <v-icon color="primary darken-2" :style="{fontSize: '150px'}">
                            {{item.iconName}}
                        </v-icon>
                        <div class="headline primary--text" >{{item.name}}</div>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout>
            <v-flex xs12 v-if="userData.userName == 'jshi'">
                <!-- <div>Before Populate Init data, please run sql scripts to delete all user data first</div> -->
                <!-- <v-btn large @click="onPopulateInitData">Populate Init Data</v-btn> -->
                <!-- <v-btn large @click="$router.push({name: 'initialImportProdDbData'})">Populate Init. Product Catalog Data</v-btn> -->
            </v-flex>

        </v-layout>
        <v-layout wrap v-if="userCanAccessProdCategory">
            <v-flex xs12>
                <!-- <v-btn large @click="onPopulateInitData">Populate Init Data</v-btn> -->
                <v-btn large @click="$router.push({name: 'itemDocs'})">Product Catalog Doc Admin.</v-btn>
            </v-flex>
            <v-flex xs12>
                <!-- <v-btn large @click="onPopulateInitData">Populate Init Data</v-btn> -->
                <v-btn large @click="$router.push({name: 'itemProdDbItems'})">Product Catalog Items Admin.</v-btn>
            </v-flex>
            <v-flex xs12>
                <!-- <v-btn large @click="onPopulateInitData">Populate Init Data</v-btn> -->
                <v-btn large @click="$router.push({name: 'itemMapNewGpItmToProdDb'})">Add New GP Item into Product Catalog</v-btn>
            </v-flex>
            <!-- <v-flex xs12>
                <div>Test Sending CS Rep Reminder Email</div>
                <v-btn large @click="sendCsRepOpenQuoteReminder">Send Cs Rep Open Quote Reminder</v-btn>
            </v-flex> -->
            <!-- <v-flex xs12>
                <div>Test Sending CS Rep Reminder Email</div>
                <v-btn large @click="$router.push({name: 'admin-item-images-canto'})">Canto Image Process</v-btn>
            </v-flex> -->
        </v-layout>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'

    export default {
        data () {
            return {
                settingItems: [
                    {pathName: 'admin-users', iconName: 'people', name: 'Users'},
                    {pathName: 'admin-regions', iconName: 'domain', name: 'Market Regions'},
                    {pathName: 'admin-territories', iconName: 'location_city', name: 'Market Territories'},
                    {pathName: 'admin-item-images', iconName: 'add_photo_alternate', name: 'Upload Item Images'},
                    {pathName: 'admin-item-image-admin', iconName: 'image_search', name: 'Item Image Admin'},
                    {pathName: 'public-site-security-admin', iconName: 'security', name: 'Public Site Security Admin.'},
                    {pathName: 'admin-item-class', iconName: 'settings_applications', name: 'Item Class Settings'},
                    {pathName: 'admin-taz-import', iconName: 'cloud_download', name: 'Import TAZ Data'},
                    {pathName: 'admin-quote-templates', iconName: 'settings_applications', name: 'Quote Templates Admin.'},
                    {pathName: 'admin-item-promotions', iconName: 'settings_applications', name: 'Item Promotion Admin.'},
                    {pathName: 'admin-item-uom-overrides', iconName: 'swap_horiz', name: 'Item UoM Overrides'},
                ]
            }
        },
        computed: {
            ...mapGetters('auth', [
                'userHasSysAdminRole',
                'userHasSalesAdminRole',
                'userData'
            ]),
            userCanAccessProdCategory() {
                return this.userHasSalesAdminRole
                // return this.userData.userName == 'jshi' 
                //     // || this.userData.userName == 'nblack@hmark.com' 
                //     // || this.userData.userName == 'jhiltz@hmark.com' 
                //     || this.userData.userName == 'bmunroe@hmark.com' 
                //     || this.userData.userName == 'hmsalesadmin@hmark.com' 
                //     || this.userData.userName == 'cdonnelly@hmark.com'
                //     || this.userData.userName == 'hmsalesadmin@hmark.com'
            }
        },
        created: function () {
            if (!this.userHasSysAdminRole) {
                this.$router.push('/')
            }
        },
        methods: {
            // ...mapActions('adminUser', [
            //     'populateInitData'
            // ]),
            onMenuClick (toPath) {
                // console.log('jobTypeId' + jobTypeId)
                this.$router.push({ name: toPath })
            },
            // onPopulateInitData() {
            //     if(!confirm('are you sure to populate data? it just need when first time init data'))
            //         return

            //     this.populateInitData()
            // }

        }
    }
</script>
